// @flow strict

import * as React from 'react';

import { Link } from 'react-router-dom';

import { selectFeatureFlag } from '@gandi/authentication';
import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import { useAppSelector } from '../../hooks/useAppSelector';

import { webhostingSizes } from '../../modules/simplehosting/prices';
import type { SimplehostingPriceSummary } from '../../modules/simplehosting/prices';

import Card from './Card';

import styles from './Offers.scss';

export type OwnProps = {
  application?: ApplicationSummary,
  availableSizes: Array<SimplehostingPriceSummary>,
  onClick: SimplehostingPriceSummary => mixed,
  currency: string,
  popularSize?: string,
  packId: string,
};

export type Props = {
  ...OwnProps,
};

const useSellingPoints = () => {
  const { __ } = useTranslator();

  const points = [
    __('1 domain name'),
    __('2 custom emails'),
    __('Gandi Customer Care'),
  ];

  return {
    starter: points.concat([
      __('1 website'),
      __('SSL Security'),
      __('App Installation'),
      __('Choose configuration'),
    ]),
    advanced: points.concat([
      __('Up to 5 websites'),
      __('SSL Security'),
      __('App Installation'),
      __('Choose configuration'),
    ]),
    pro: points.concat([
      __('Up to 10 websites'),
      __('SSL Security'),
      __('App Installation'),
      __('Choose configuration'),
      __('Booster'),
    ]),
    business: points.concat([
      __('Up to 15 websites'),
      __('SSL Security'),
      __('App Installation'),
      __('Choose configuration'),
      __('Booster'),
      __('Extendable storage'),
    ]),
  };
};

const featureFlagProps = {
  featureFlagName: 'ff-shs-legacy-creation',
};

export default function Offers({
  application,
  availableSizes,
  onClick,
  currency,
  popularSize,
  packId,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const sellingPoints = useSellingPoints();

  const FF_SHS_LEGACY_CREATION = useAppSelector(state =>
    selectFeatureFlag(state, featureFlagProps),
  );

  return (
    <Base marginBottom="small" paddingY="base">
      <Base
        grid
        gap="xsmall"
        className={styles.wpcardsContainer}
        marginBottom="small"
      >
        {availableSizes.map(size => {
          const productName = size.product.name;
          const isPopular = popularSize ? popularSize === productName : false;
          return (
            <Card
              key={productName}
              currency={currency}
              infos={size}
              size={productName}
              argumentatives={
                webhostingSizes.includes(productName)
                  ? // $FlowIssue[prop-missing]
                    sellingPoints[productName]
                  : []
              }
              onClick={() => onClick(size)}
              isPopular={isPopular}
              application={application}
              packId={packId}
            />
          );
        })}
      </Base>
      {FF_SHS_LEGACY_CREATION && (
        <Link to="/simplehosting/legacy">
          {__(
            'Click here to find former Simple Hosting instances from S+ to XXL',
          )}
        </Link>
      )}
    </Base>
  );
}
